import { Pause } from '@mui/icons-material';

import { Button } from '@/components';
import { PlayArrowOutlinedIcon } from '@/icons';
import { EVENT_CONSTANTS } from '@/services';
import {
  playerThunks,
  selectActiveChapterId,
  selectIsEpisodePlaying,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { EpisodeCard, Referrer } from '@/types';

export const PreviewButton = ({
  episode,
  referrer,
}: {
  episode: EpisodeCard;
  referrer: Referrer;
}) => {
  const dispatch = useAppDispatch();

  const activeChapterId = useAppSelector(selectActiveChapterId);
  const isTrailerPlaying =
    useAppSelector(state => selectIsEpisodePlaying(state, episode.episodeId)) &&
    activeChapterId === episode.trailerId;

  return (
    <Button
      variant="tertiary"
      label="Preview"
      fullWidth={false}
      skinny={true}
      startIcon={isTrailerPlaying ? <Pause /> : <PlayArrowOutlinedIcon />}
      colorOverride="white"
      onClick={e => {
        e?.preventDefault();
        e?.stopPropagation();
        dispatch(
          playerThunks.chapterPlayPressed({
            activeChapter: {
              episodeId: episode.episodeId,
              chapterId: episode.trailerId,
            },
            location: { ...referrer, button: EVENT_CONSTANTS.BUTTON.PREVIEW },
            referrer,
          }),
        );
      }}
      disabled={episode.isArchived}
    />
  );
};
